export const COLORS = {
  dark: {
    background: "#0c1324",
    surface: "#0c1324",
    surfaceDim: "#0c1324",
    surfaceBright: "#33394c",
    surfaceContainerLowest: "#070d1f",
    surfaceContainerLow: "#151b2d",
    surfaceContainer: "#191f31",
    surfaceContainerHigh: "#23293c",
    surfaceContainerHighest: "#2e3447",
    surfaceVariant: "#2e3447",
    onSurface: "#dce1fb",
    onSurfaceVariant: "#c2c6d6",
    outline: "#8c909f",
    outlineVariant: "#424754",
    primary: "#adc6ff",
    onPrimary: "#002e6a",
    primaryContainer: "#4d8eff",
    onPrimaryContainer: "#00285d",
    secondary: "#d0bcff",
    onSecondary: "#3c0091",
    secondaryContainer: "#571bc1",
    onSecondaryContainer: "#c4abff",
    error: "#ffb4ab",
    onTertiaryFixedVariant: "#444749",
    inversePrimary: "#005ac2",
  },
  light: {
    background: "#f4f6ff",
    surface: "#f4f6ff",
    surfaceDim: "#dde1f0",
    surfaceBright: "#f4f6ff",
    surfaceContainerLowest: "#ffffff",
    surfaceContainerLow: "#eef0ff",
    surfaceContainer: "#e8eaf8",
    surfaceContainerHigh: "#e2e4f2",
    surfaceContainerHighest: "#dcdeed",
    surfaceVariant: "#dde2f9",
    onSurface: "#191c27",
    onSurfaceVariant: "#424659",
    outline: "#747689",
    outlineVariant: "#c4c6db",
    primary: "#005ac2",
    onPrimary: "#ffffff",
    primaryContainer: "#d8e2ff",
    onPrimaryContainer: "#001a42",
    secondary: "#5c18c5",
    onSecondary: "#ffffff",
    secondaryContainer: "#e9ddff",
    onSecondaryContainer: "#23005c",
    error: "#ba1a1a",
    onTertiaryFixedVariant: "#444749",
    inversePrimary: "#adc6ff",
  },
};